import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth0 } from '@auth0/auth0-react';

// Create a new context
const AuthContext = createContext();

// AuthProvider component that will wrap your application
export const AuthProvider = ({ children }) => {
    const { isAuthenticated, user, loginWithRedirect, logout, getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState(null);

    useEffect(() => {
        const fetchToken = async () => {
            if (isAuthenticated) {
                try {
                    const token = await getAccessTokenSilently();
                    setToken(token);
                } catch (error) {
                    console.error('Error getting access token', error);
                }
            }
        };

        fetchToken();
    }, [isAuthenticated, getAccessTokenSilently]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, loginWithRedirect, logout, token }}>
            {children}
        </AuthContext.Provider>
    );
};

// Define prop types for the AuthProvider component
AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

// Hook to use the AuthContext
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
